import compose from 'lodash/flowRight';
import orderBy from 'lodash/orderBy';
import { withProps, acceptProps } from 'vue-compose';

import dataView from '~lib/common/hoc/dataView';

import CaseMonitorProcedures from './CaseMonitorProcedures.vue';
import queries from '~lib/common/queries/Treatment';

const enhance = compose(
  dataView({ queries }),
  withProps({
    monitorProcedures: props => orderBy(
      props.data.filter(t => t.category === 'MONITOR_PROCEDURE'),
      'displayOrder',
    ),
  }),
  acceptProps(['data']),
);

export default enhance(CaseMonitorProcedures);
